class PredictiveSearch extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.onTrigger = this.onTrigger.bind(this)
    this.listeners.add(document, 'click', this.onTrigger)

    this.listeners.add(
      this.els.input.element,
      'input',
      window.BAO.Utils.debounce((e) => {
        this.onChange(e)
      }, 500).bind(this),
    )
  }

  onTrigger (event) {
    const triggerEl = event.target.closest(
      '[data-predictive-search-external-el="trigger"]',
    )
    if (!triggerEl) return

    this.resetSearch()

    this.els.input.element.focus()
  }

  onChange () {
    const searchTerm = this.els.input.element.value.trim()

    this.hideDefault(true)
    this.hideResults(false)

    if (!searchTerm.length) {
      this.hideDefault(false)
      this.hideResults(true)
      return
    }

    this.getSearchResults(searchTerm)
    this.getProductSearch(searchTerm)
  }

  getSearchResults (searchTerm) {
    fetch(
      `${window.Shopify.routes.root}search/suggest?q=${searchTerm}&resources[type]=query,page,product,collection,article&resources[limit]=6&resources[limit_scope]=each&resources[options][unavailable_products]=last&resources[options][fields]=body,product_type,tag,title,variants.title,vendor&section_id=drawer-search-results`,
    )
      .then((response) => {
        if (!response.ok) {
          const error = new Error(response.status)
          throw error
        }

        return response.text()
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-drawer-search-results').innerHTML
        this.els.results.element.innerHTML = resultsMarkup

        this.hideResults(false)
      })
      .catch((error) => {
        this.hideResults(true)
        this.hideDefault(false)
        throw error
      })
  }

  getProductSearch (searchTerm) {
    fetch(
      `search/suggest.json?q=${searchTerm}&resources[type]=query,product,collection&resources[limit]=5&resources[limit_scope]=each&resources[options][unavailable_products]=last&resources[options][fields]=body,product_type,tag,title,variants.title,vendor`,
    )
      .then((response) => response.json())
      .then((suggestions) => {
        const productSuggestions = suggestions.resources.results.products
        const collectionSuggestions = suggestions.resources.results.collections

        if (
          productSuggestions.length === 0 &&
          collectionSuggestions.length === 0
        ) {
          this.hideDefault(true)
        }
      })
  }

  hideResults (state) {
    this.els.results.element.setAttribute('aria-hidden', state)
  }

  hideDefault (state) {
    this.els.default.element.setAttribute('aria-hidden', state)
  }

  resetSearch () {
    this.els.input.element.value = ''
    this.hideDefault(false)
    this.hideResults(true)
  }
}

if (!customElements.get('predictive-search')) {
  customElements.define('predictive-search', PredictiveSearch)
}
